import { CardSkeleton } from './CardSkeleton';

interface CardsLoadingProps {
  numberOfItems?: number;
}

export function CardsSkeleton({
  numberOfItems = 5,
}: Readonly<CardsLoadingProps>) {
  return (
    <div className='grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
      {Array.from({ length: numberOfItems }, (_, index) => (
        <CardSkeleton
          key={`card-loading-${index}`}
          className='dark:bg-gray-200'
        />
      ))}
    </div>
  );
}
